<template>
    <div class="row">
      <div class="col-12">
        <h2 class="mt-5 pb-2">Quick start:</h2>
      </div>
      <div class="col-12">
        <div>1. Install tracing package via pip in your virtual environment:</div>
        <div class=" text-monospace mt-2"><code>pip install pycrunch-trace</code>
        </div>
      </div>
        <div class="col-12">
          <div class="mt-5">2. Add attribute <code>@trace</code> to the method you want to record
          </div>

          <code style="white-space: pre-wrap; " >
from pycrunch_trace.client.api import trace

@trace
def run():
    some_code()
          </code>
          <div class="mt-2 text-secondary">Your recording will be stored in your working directory</div>

          </div>
      <div class="col-12">
        <div class="mt-5 mb-5">3. Open your recording in <a :href="webAppLink" target="_blank">web app</a> to analyze.</div>
      </div>
      </div>


</template>
<script>
  import { track } from '../../ga-events'
  import config from '../../config'

  export default {
    name: 'pc-quick-start',
    data () {
      return {
        install_from_disk_visible: false,
        activeTabName: 'pytest',
        webAppLink: config.webapp_link,
      }
    },
    methods: {
      handleTabClick (tab, event) {
        track('home', 'framework_tab_click', this.activeTabName)
      },
    },
  }
</script>
<style scoped>

  .help__link {
    border-bottom: 1px dashed #007bff;
    cursor: pointer;
    color: #007bff;
  }

</style>